export default __webpack_public_path__ + "static/website_monitor-5ccfbfabaa56373aea8f12695d1bf23e.png";